import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { getNavbarProxy } from "@/stores/navbar.store";
import React from "react";
import { useLocation } from "react-router-dom";

export function Navbar(props: { children: JSX.Element }) {
  const navbarProxy = getNavbarProxy();
  const location = useLocation();
  return (
    <SidebarInset>
      <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
        <div className="flex items-center gap-2 px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="h-4 mr-2" />
          <Breadcrumb>
            <BreadcrumbList>
              {navbarProxy.navbarProxyMap
                .get("/" + location.pathname.split("/")[1])
                ?.map((el, index) => (
                  <React.Fragment key={index}>
                    <BreadcrumbItem className="hidden md:block">
                      <BreadcrumbLink href="#">{el}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {index + 1 !=
                      navbarProxy.navbarProxyMap.get(
                        "/" + location.pathname.split("/")[1]
                      )?.length && (
                      <BreadcrumbSeparator className="hidden md:block" />
                    )}
                  </React.Fragment>
                ))}
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </header>
      {props.children}
    </SidebarInset>
  );
}
